<div class="modal-header">
  <button type="button" class="close" ng-click="cancel()">&times;</button>
  <h3 class="modal-title">Configurações</h3>
</div>
<div class="modal-body">
  <form name="form">
    <div class="form-group">
      <label for="widget-title" class="control-label">Título</label>
      <input type="text" class="form-control" name="widgetTitle" ng-model="result.title">
    </div>
    <div class="form-group">
      <label class="control-label">Propriedade</label>
      <ui-select ng-model="result.dataModelOptions.propriedade" theme="bootstrap" id="propriedade" name="propriedade" append-to-body="true">
        <ui-select-match placeholder="Propriedade atual ({{$root.currentPropriedade.descricao}})">
          {{$select.selected.descricao | capitalize}}
          <span class="clear-btn" ng-click="$event.stopPropagation(); result.dataModelOptions.propriedade = null"><i class="fa fa-remove true-clear-icon"></i></span>
        </ui-select-match>
        <ui-select-choices repeat="propriedade in result.data.propriedades | orderBy: 'descricao' | filter: $select.search track by propriedade.id">
          <span class="form-group" ng-bind-html="propriedade.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="form-group">
      <label class="control-label">
        Talhão
        <span ng-show="$root.globalGleba && !result.dataModelOptions.gleba">(usando geral - {{$root.globalGleba.descricao}})</span>
      </label>
      <ui-select ng-model="result.dataModelOptions.gleba" theme="bootstrap" id="gleba" name="gleba" append-to-body="true">
        <ui-select-match placeholder="{{$root.globalGleba ? 'Talhão atual ('+$root.globalGleba.descricao+')' : 'Selecione o talhão'}}">
          {{$select.selected.descricao | capitalize}}
          <span class="clear-btn" ng-click="$event.stopPropagation(); result.dataModelOptions.gleba = null"><i class="fa fa-remove true-clear-icon"></i></span>
        </ui-select-match>
        <ui-select-choices repeat="gleba in result.dataModelOptions.propriedade.glebas | orderBy: 'descricao' | filter: $select.search track by gleba.id">
          <span class="form-group" ng-bind-html="gleba.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="form-group">
      <label class="control-label">
        Safra
        <span ng-show="$root.globalSafra && !result.dataModelOptions.safra">(usando geral - {{$root.globalSafra.descricao}})</span>
      </label>
      <ui-select ng-model="result.dataModelOptions.safra" theme="bootstrap" id="safra" name="safra" append-to-body="true">
        <ui-select-match placeholder="{{$root.globalSafra ? 'Safra atual ('+$root.globalSafra.descricao+')' : 'Selecione a safra'}}">
          {{$select.selected.descricao}}
        </ui-select-match>
        <ui-select-choices repeat="safra in result.data.safras | orderBy: 'descricao' | filter: $select.search track by safra.id">
          <span class="form-group" ng-bind-html="safra.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="form-group">
      <label class="control-label">Cultura</label>
      <ui-select ng-model="result.dataModelOptions.cultura" theme="bootstrap" id="cultura" name="cultura" append-to-body="true">
        <ui-select-match placeholder="Selecione a cultura">
          {{$select.selected.descricao | capitalize}}
          <span class="clear-btn" ng-click="$event.stopPropagation(); result.dataModelOptions.cultura = null"><i class="fa fa-remove true-clear-icon"></i></span>
        </ui-select-match>
        <ui-select-choices repeat="cultura in result.data.culturas | orderBy: 'descricao' | filter: $select.search track by cultura.id">
          <span class="form-group" ng-bind-html="cultura.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="form-group">
      <label class="control-label">Grupo de insumos</label>
      <ui-select ng-model="result.dataModelOptions.grupo_insumo"
                 theme="bootstrap"
                 id="grupo_insumo"
                 name="grupo_insumo"
                 required
                 ng-disabled="!(result.dataModelOptions.propriedade || $root.currentPropriedade) || !(result.dataModelOptions.gleba || $root.globalGleba)"
                 append-to-body="true">
        <ui-select-match allow-clear="true" placeholder="Selecione o grupo de insumos">{{$select.selected.descricao | capitalize}}</ui-select-match>
        <ui-select-choices repeat="grupo_insumo in (result.dataModelOptions.propriedade || $root.currentPropriedade).grupos_insumo | orderBy: 'descricao' | filter: $select.search track by grupo_insumo.id">
          <span class="form-group" ng-bind-html="grupo_insumo.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="form-group">
      <label class="control-label">Tipo de praga</label>
      <ui-select ng-model="result.dataModelOptions.tipo" theme="bootstrap" id="tipo" name="tipo" required append-to-body="true">
        <ui-select-match allow-clear="true" placeholder="Selecione o tipo de praga">{{$select.selected.descricao | capitalize}}</ui-select-match>
        <ui-select-choices repeat="tipo in result.data.tipos | orderBy: 'descricao' | filter: $select.search track by tipo.id">
          <span class="form-group" ng-bind-html="tipo.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="cancel()">Cancelar</button>
  <button type="button" class="btn btn-primary" ng-click="ok()">OK</button>
</div>
